__turbopack_context__.v({
  "divider": "Divider-module__ahk_sG__divider",
  "featurette": "Divider-module__ahk_sG__featurette",
});
